import instance from "../../../../util/axios";
import { Result } from "../../../../schema";
import { AppListLayout, BtnInfo, IntelligentTableView } from "../dto";
import { AxiosResponse } from "axios";
import { Description } from "../../../../component/schema";

export class IntelligentTableService {
  static async getTableAndView(
    tableId: string = "c9588defb00548e3b617dfc389f0c6a8"
  ): Promise<AxiosResponse<Result<IntelligentTableView[]>>> {
    return instance.post<Result<IntelligentTableView[]>>(
      `/crm/intelligentTableView/getTableAndView`,
      {
        tableId: tableId,
      }
    );
  }

  static async getNewFieldDescriptionList(
    viewId: string
  ): Promise<AxiosResponse<Result<Description[]>>> {
    return instance.post<Result<Description[]>>(
      "/crm/intelligentTableView/getNewFieldDescriptionList",
      {
        viewId,
      }
    );
  }

  static async getAppListLayoutByViewId(
    viewId: string
  ): Promise<AxiosResponse<Result<AppListLayout>>> {
    return instance.post<Result<AppListLayout>>(
      "/crm/intelligentTableView/getAppListLayoutByViewId",
      {
        viewId,
      }
    );
  }

  static async getViewButton(
    viewId: string
  ): Promise<AxiosResponse<Result<BtnInfo[]>>> {
    return instance.get<Result<BtnInfo[]>>(
      `/crm/intelligentTableView/getViewButton?viewId=${viewId}`
    );
  }

  static async getTable(
    tableId: string
  ): Promise<AxiosResponse<Result<{ name: string }>>> {
    return await instance.post<
      Result<{
        name: string;
      }>
    >(`/crm/intelligentTableView/getTableMsg`, {
      tableId: tableId || "c9588defb00548e3b617dfc389f0c6a8",
    });
  }
}
